.fdi.wc.tooltip{
  position: relative;
  z-index: 99999;
  > span{
    position: absolute;
    background: white;
    border: solid 1px #ccc;
  }
}
